import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
// import { notification } from 'antd';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';
import { clearLocalStorage } from '../utils/common';

export class LocationsStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      locations: [],
      offset: 0,
      limit: 15,
      search: null,
      sort: null,
      order: null,
      action: null,
      locationId: null,
      locationName: '',
    });
  }

  setAction(task, data) {
    this[task] = data;
  }

  resetData() {
    this.offset = 0;
    this.limit = 15;
    this.search = null;
    this.sort = null;
    this.order = null;
    this.locations = [];
  }

  async setData(task, data, getLocation = true) {
    this[task] = data;
    if (getLocation) {
      this.getLocationList(this.offset, this.limit, this.search, this.sort, this.order);
    }
  }

  async getLocationList(offset = 0, limit = 15, search = null, sort = null, order = null) {
    this.loading = true;
    let queryOption = {};
    queryOption.offset = offset;
    queryOption.limit = limit;
    if (search) {
      queryOption.search = search;
    }
    if (sort) {
      queryOption.sort = sort;
    }
    if (order) {
      queryOption.order = order;
    }
    try {
      let url = `${config.api.url}/${config.api.version}/location`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const locations = res.body || {};
        return (this.locations = locations);
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createLocation(data) {
    this.loading = true;
    try {
      const detail = {
        name: data.name,
        contactPerson: data.contactPerson,
        email: data.email,
        phoneNumber: data.phoneNumber,
        homeNumber: data.homeNumber,
        road: data.road,
        subDistrict: data.subDistrict,
        district: data.district,
        province: data.province,
        postcode: data.postcode,
        description: data.description,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/location`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateLocation(data) {
    this.loading = true;
    try {
      const detail = {
        // id: data.id,
        name: data.name,
        contactPerson: data.contactPerson,
        email: data.email,
        phoneNumber: data.phoneNumber,
        homeNumber: data.homeNumber,
        road: data.road,
        subDistrict: data.subDistrict,
        district: data.district,
        province: data.province,
        postcode: data.postcode,
        description: data.description,
      };
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/location/${data.id}`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async deleteLocation(id) {
    this.loading = true;
    try {
      const res = await rp
        .delete(`${config.api.url}/${config.api.version}/location/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      console.log('error', err);
      throw err;
    } finally {
      this.loading = false;
    }
  }
}

export default new LocationsStore();
